// components/Header.tsx
import UserMenu from 'components/Menu/UserMenu'
import styled from 'styled-components'
import SearchButton from './components/Search/SearchButton'

const Wrapper = styled.div`
  display: flex;
  // width: 1128px;
  width: 100%;
  height: 56px;
  // max-width: 1280px;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`

export default function Header({ onClickSearchBtn }: { onClickSearchBtn: () => void }) {
  return (
    <Wrapper>
      <SearchButton onClick={onClickSearchBtn} />
      {/* <WalletWidget /> */}
      <UserMenu />
    </Wrapper>
  )
}
